export default __webpack_public_path__ + "static/media/atena-solutions.9276c584.svg";